import React from 'react';
import GenericCRUD from 'src/shared/genericCRUD';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { getData } from 'src/api/api';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Loader from 'src/shared/defaultLoader';

export default function GroupType() {
  const { register, handleSubmit } = useForm();
  const { t } = useTranslation();
  let { id } = useParams();
  const getQueryFn = async ({ queryKey }) => await getData('group-type', { queryKey });

  const { data, error, isLoading, isError } = useQuery(['group-type', { id }], getQueryFn);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <span>Error : {error.message}</span>;
  }

  return (
    <GenericCRUD objectName={'group-type'} handleSubmit={handleSubmit} data={data}>
      <Grid item xs={12} sm={6}>
        <FormControl variant="standard" fullWidth={true}>
          <TextField
            {...register('group_type_name')}
            required
            autoComplete="off"
            id="group_type_name"
            name="group_type_name"
            label={t('GROUP_TYPE_NAME')}
            fullWidth
            variant="standard"
            defaultValue={data.group_type_name}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl variant="standard" fullWidth={true}>
          <TextField
            {...register('group_type_order')}
            required
            id="group_type_order"
            name="group_type_order"
            label={t('GROUP_TYPE_ORDER')}
            fullWidth
            autoComplete="family-name"
            variant="standard"
            defaultValue={data.group_type_order}
          />
        </FormControl>
      </Grid>
    </GenericCRUD>
  );
}
